export const VISIT_CONSOLE_APP = 'visit_console_app'

